import User from './User'
import Hotel from './Hotel'
import FetchData from './FetchData';

class HotelAdmin extends User{
    constructor(username,email,profilePic,auth){
        super(username,email,profilePic,auth);
    }


    addHotel(hotel) {
        var data = {
            name: hotel.hotelName,
            location: hotel.locationName,
            identifier: hotel.hotelUrl, 
            photoLink: hotel.photoLink,
            description: hotel.description, 
            price: hotel.price
        };

        var response = FetchData.makeAuthRequest("https://euopendata.herokuapp.com/hotel/add_hotel", "POST", data, this.auth);
        return response; // return response.message;
    }

    getAllHotels() {
        var data = {};

        var response = FetchData.makeAuthRequest("https://euopendata.herokuapp.com/owner/hotels", "GET", data, this.auth);
        return response;
    }

    removeHotel(hotel){
            var data = {
                id : hotel.id,
                identifier : hotel.identifier,
                hotelName : hotel.hotelName,
                locationName : hotel.locationName,
                photoLink : hotel.photoLink,
                description : hotel.description,
                price : hotel.price,
                averageRating : hotel.averageRating,
                votes : hotel.votes
            };

            var response = FetchData.makeAuthRequest("https://euopendata.herokuapp.com/hotel/delete_hotel", "DELETE", data, this.auth);
            /*var response=null;
            let req=new XMLHttpRequest();
            req.open('DELETE','https://euopendata.herokuapp.com/hotel/delete_hotel',false);
            req.send();

            if(req.readyState === 4 && req.status === 200){
                response=JSON.parse(req.responseText);
            }
            else{
                alert("Error");
            }*/
            
            return response;    
    }

}

export default HotelAdmin;